module.exports = __webpack_public_path__ + "img/jinlogo.7d840184.png";